// eslint-disable-next-line
import { h, Component } from 'preact';
import IconArrowRight from './../IconArrowRight';

import styles from './index.scss';

class Hide extends Component {
    state = {
        showPrompt: false,
    };

    handlePanelClick = e => {
        e.preventDefault();
        e.stopPropagation();
        this.setState({
            showPrompt: true,
        });
    };

    handleConfirmButtonClick = e => {
        e.preventDefault();
        e.stopPropagation();

        this.props.onHidePromptAction();
    };

    handleRefuseButtonClick = e => {
        e.preventDefault();
        e.stopPropagation();
        this.setState({
            showPrompt: false,
        });
    };

    renderMessage = () => {
        const { miniCart_dontShowReminder, miniCart_turnOffReminder, Yes, No } = this.props;

        if (this.state.showPrompt) {
            return (
                <div className={styles.hide__prompt}>
                    <p className={styles.hide__promptMessage}>{miniCart_turnOffReminder}</p>
                    <div className={styles.hide__promptButtonsWrap}>
                        <button className={styles.hide__promptButton} onClick={this.handleConfirmButtonClick}>
                            {Yes}
                        </button>
                        <button className={styles.hide__promptButton} onClick={this.handleRefuseButtonClick}>
                            {No}
                        </button>
                    </div>
                </div>
            );
        }

        return (
            <p className={styles.hide__message}>
                <span>{miniCart_dontShowReminder}</span>
                &nbsp;
                <IconArrowRight />
            </p>
        );
    };

    render() {
        return (
            <div
                className={`${styles.hide} ${this.state.showPrompt ? '' : styles.hide_initial}`}
                onClick={this.handlePanelClick}
            >
                {this.renderMessage()}
            </div>
        );
    }
}

export default Hide;
